module.exports = __webpack_public_path__ + "img/line-logo.accd6701.svg";